import { validEmail } from '@origin-digital/validation';

const validateUsername = (username: string = ''): string | void => {
  if (!username) {
    return 'Please enter an email';
  }
  return validEmail({ error: "Oops, that doesn't look like an email address" })(username);
};

export { validateUsername };
